import Config from '../config'
import { defineStore } from 'pinia'
import { FetchWrapper, Utils } from '@/lib'

export const useTitleStore = defineStore('titleStore', {
    state: () => ({
        titlesMap: {},
        allTitles: [],
        sourceTitles: []
    }),
    persist: false,
    actions: {
        flushTitles() {
            this.titlesMap = {}
            this.allTitles = []
            this.sourceTitles = []
        },

        async getTitles(endpoint, component) {
            var self = this
            return await FetchWrapper.get(`${Config.BASE_URL}/${endpoint}`)
            .then((titles) => {
                if (!titles || !titles.length) {
                    return []
                }
                let fileredTitles = []
                for (let i = 0; i < titles.length; i++) {
                    let title = titles[i]
                    if (title.title_id == "1") {
                        // Cannot add title_id 1 to a quest
                        continue
                    }
                    fileredTitles.push(title)
                    self.titlesMap[title.title_id] = self.titlesMap[title.title_id] || {}
                    self.titlesMap[title.title_id] = {
                        ...self.titlesMap[title.title_id],
                        ...title
                    }
                }
                return fileredTitles
            }).catch((error) => {
                Utils.notifyError(component, error)
                return Promise.reject(error)
            })
        },

        async getAllTitles(component) {
            if (this.allTitles && this.allTitles.length) {
                return this.allTitles
            }
            this.allTitles = await this.getTitles('all-titles', component)
            return this.allTitles
        },

        async getSourceTitles(component) {
            if (this.sourceTitles && this.sourceTitles.length) {
                return this.sourceTitles
            }
            this.sourceTitles = await this.getTitles('titles', component)
            return this.sourceTitles
        },

        async getTitleByIdAsync(component, titleId, force = false) {
            const self = this

            if (!force && this.titlesMap[titleId]) {
                return this.titlesMap[titleId]
            }

            return await FetchWrapper.get(`${Config.BASE_URL}/title/${titleId}`)
            .then((title) => {
                self.updateTitleByIdSync(titleId, title)
                return title
            }).catch((error) => {
                Utils.notifyError(component, error)
                return Promise.reject(error)
            })
        },

        // Relies on cache being already populated
        getTitleByIdSync(titleId) {
            return this.titlesMap[titleId] || null
        },

        // Update cache
        updateTitleByIdSync(titleId, titleUpdate) {
            for (let i = 0; i < this.sourceTitles.length; i++) {
                let title = this.sourceTitles[i]
                if (title.title_id == titleId) {
                    this.sourceTitles[i] = {...title, ...titleUpdate}
                    this.titlesMap[titleId] = titleUpdate
                    break;
                }
            }
            for (let i = 0; i < this.allTitles.length; i++) {
                let title = this.allTitles[i]
                if (title.title_id == titleId) {
                    this.allTitles[i] = {...title, ...titleUpdate}
                    this.titlesMap[titleId] = titleUpdate
                    break;
                }
            }
        },
    }
})
